export default "__VITE_ASSET__DDw5a2vK__"